import React from 'react';
import Star from './star';
import './product-rating.scss';

const round = number => {
  switch (true) {
    case number < 0.1:
      return 0;
    case number >= 0.1 && number < 0.5:
      return 0.25;
    case number >= 0.5 && number < 0.75:
      return 0.5;
    case number >= 0.75 && number < 1:
      return 0.75;
    default:
      return 1;
  }
};

const StarRating = ({ rating, reviews }) => {
  return (
    <div className="product-rating">
      {rating ? (
        <>
          {[...Array(5).keys()]
            .map(i => round(rating - i))
            .map(f => (
              <Star fill={f} />
            ))}
          <span className="product-rating__review-count">{`(${reviews})`}</span>
        </>
      ) : null}
    </div>
  );
};

export default StarRating;
